
// frontend/src/routes/paths.js
export const PATHS = {
  OWNER_DASHBOARD: '/dashboard',
  ADMIN_DASHBOARD: '/dashboard',
  PROFESSIONAL_DASHBOARD: '/dashboard/professional',
  CUSTOMER_HOME: '/',
  PORTAL_ADMIN_DASHBOARD: '/portal-admin',
};
